import { RegularButton } from 'fronton-react';
import React, { RefObject, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useInView from 'react-cool-inview';
import { selectColorButton } from '../styles';
import { ColorPaletteIcon } from './color-palette-icon';
import { ButtonWrapperForIntegration } from './button-wrapper-for-integration';

type TProps = {
  openChooseColorModal: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  dataForIntegration: string;
  isTintAvailable: boolean;
  sendGaImpressions: () => void;
};

export const ChooseColorButton = ({
  dataForIntegration,
  openChooseColorModal,
  isTintAvailable,
  sendGaImpressions,
}: TProps) => {
  const { t } = useTranslation();
  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      sendGaImpressions();
    }
  }, [inView, sendGaImpressions]);

  return (
    <ButtonWrapperForIntegration
      dataQa="select-tint-color-general-button-pdp"
      dataForIntegration={dataForIntegration}
      openChooseColorModal={openChooseColorModal}
      isTintAvailable={isTintAvailable}
    >
      <RegularButton
        ref={ref as RefObject<HTMLButtonElement>}
        className={selectColorButton}
        iconLeft={<ColorPaletteIcon />}
        size="m"
        variant="outline"
      >
        {t('product-info.pdp-select-tint-color.buttons.choose_color')}
      </RegularButton>
    </ButtonWrapperForIntegration>
  );
};
